import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import LdsImage from "../../components/LdsImage/index.jsx";
import reportTemplateFindingsNegative from "../../assets/module-5/report-template-findings-negative.png";
import reportTemplateFindingsPositive from "../../assets/module-5/report-template-findings-positive.png";
import LdsBlockList from "../../components/LdsBlockList/LdsBlockList.jsx";
import { FigureCaption } from "react-bootstrap";
import exampleReport from "../../assets/module-5/example-report.png";
import References from "../../components/References/index.jsx";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_0_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8 module-content">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">5.0.3 Findings</h1>
            <p className="mt-3 mb-0">Estimated time to complete: 2 minutes</p>
          </section>
          <section>
            <LdsBlockList
              items={[
                {
                  title: "Indications for Ordering",
                  bookmarked: false,
                  iconSlug: "pin",
                  active: false,
                },
                {
                  title: "Technique",
                  bookmarked: false,
                  iconSlug: "wrench",
                  active: false,
                },
                {
                  title: "Findings",
                  bookmarked: true,
                  iconSlug: "memo",
                },
                {
                  title: "Impression",
                  bookmarked: true,
                  iconSlug: "mag",
                  active: false,
                },
              ]}
            />
            <div className="content-block callout mb-5 mt-3">
              <LdsImage
                src={reportTemplateFindingsNegative}
                alt="Example of a negative scan report: 'FINDINGS: There is no increased Amyvid uptake seen in the cortical cerebral gray matter. The brain shows normal gray-white contrast throughout. The cerebellum has no evidence of abnormal uptake.'"
              />
              <FigureCaption>Example of a Negative Scan Report</FigureCaption>
              <br className="mb-3" />
              <LdsImage
                src={reportTemplateFindingsPositive}
                alt="Example of a positive scan report: 'FINDINGS: There is diffusely increased Amyvid uptake throughout the cortical cerebral gray matter. Most intense uptake is seen in the pre-frontal, lateral temporal, and parietal areas, with these areas showing clear loss of the normal gray-white contrast. The cerebellum has no evidence of abnormal uptake.'"
              />
              <FigureCaption>Example of a Positive Scan Report</FigureCaption>
            </div>
            <div className="content-block mb-5 mt-3">
              <h2 className="h5 bold">3. Findings</h2>
              <ul className="pl-0">
                <li>
                  Describe the pattern of radiotracer uptake within the cortex
                </li>
                <li>
                  Specify the degree and location of cerebral atrophy (if
                  present)
                </li>
                <li className="bold">
                  Describe in what 2 or more regions you see a reduction or loss
                  of gray/white matter differentiation<sup>1</sup>
                </li>
              </ul>
            </div>
            <div className="content-block callout mb-5 mt-3">
              <h3 className="h6 bold">
                Positive scan<sup>2</sup>
              </h3>
              <ul style={{ margin: "0 0 0 48px", padding: 0 }}>
                <li>
                  2 or more brain areas (each larger than a single cortical
                  gyrus) in which there is reduced or absent gray-white
                  contrast. This is the most common appearance of a positive
                  scan
                </li>
              </ul>
              <div className="mt-1 mb-2">OR</div>
              <ul style={{ margin: "0 0 0 48px", padding: 0 }}>
                <li>
                  1 or more areas in which gray matter radioactivity is intense
                  and clearly exceeds radioactivity in adjacent white matter
                </li>
              </ul>
              <ul>
                <li>
                  Describe areas with cerebral cortical uptake more intense than
                  white matter uptake (if present) and note the location
                </li>
              </ul>
            </div>
          </section>
          <div className="text-center">
            <LdsButton
              classes="orange-button mt-3"
              onClick={() => window.open(exampleReport, "_blank")}
            >
              Download Example Report
            </LdsButton>
          </div>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Minoshima S, Drzezga AE, Barthel H, et al. SNMMI Procedure
                Standard/EANM Practice Guideline for Amyloid PET Imaging of the
                Brain 1.0. <em>J Nucl Med.</em> 2016;57(8):1316-1322.
              </li>
              <li>
                Trembath L, et al. Technical considerations in brain amyloid PET
                imaging with 18F-Florbetapir. <em>J Nucl Med Technol.</em>{" "}
                2015;43(3):175-184.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_5_0_3;
